import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { RapidStorSettings } from './rapidstor';

export const validatePassword = (password: string): boolean => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/;
    return passwordRegex.test(password);
};

export const validateString = (value: string): boolean => {
    if (value === '') return false;
    if (value === undefined) return false;
    if (value === null) return false;
    if (value.trim() === '') return false;
    if (!value) return false;

    return true;
};

export const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    return emailRegex.test(email);
}

export const excludedInputs = (location: Location): string[] => {
    const excl: string[] = [
        'cardType',
        'boxShopCouponId',
        'pickupLocation',
        'autobill',
        'autobillBsbNumber',
        'autobillAccountNumber',
        'autobillCreditCardExpiryMonth',
        'autobillCreditCardExpiryYear',
        'autobillCreditCardNumber',
        'autobillCreditCardCsv',
        'autobillCreditCardName',
        'bank',
    ];

    if (!RapidStorSettings(location).alternateContact().show()) {
        excl.push('title_alternate');
        excl.push('firstName_alternate');
        excl.push('lastName_alternate');
        excl.push('phone_alternate');
        excl.push('email_alternate');
        excl.push('address_alternate');
        excl.push('city_alternate');
        excl.push('state_alternate');
        excl.push('postcode_alternate');
    }

    if (!RapidStorSettings(location).dateOfBirth().show()) {
        excl.push('dateOfBirth');
    }

    if (location.rapidstor.wizards.moveinSingle.hideDriversLicenceState) {
        excl.push('driverLicenseState');
    }

    if (
        location.rapidstor.wizards.moveinSingle.hideDriversLicence ||
        !location.rapidstor.wizards.moveinSingle.allowIdUpload
    ) {
        excl.push('driverLicenseNumber');
        excl.push('driverLicenseState');
        excl.push('idDocumentNumber');
    }

    if (!RapidStorSettings(location).postalCode().show()) {
        excl.push('postcode');
        excl.push('postcode_alternate');
    }

    if (!RapidStorSettings(location).state().show()) {
        excl.push('state');
        excl.push('state_alternate');
    }

    if (!RapidStorSettings(location).insurance().manualEntry().required()) {
        excl.push('declaredValueOfGoods');
    }

    if (RapidStorSettings(location).insurance().optional()) {
        excl.push('insuranceCoverage');
    }

    if (!RapidStorSettings(location).paymentForm().show()) {
        excl.push('cardHolderName');
        excl.push('cardNumber');
        excl.push('cardExpiryMonth');
        excl.push('cardExpiryYear');
        excl.push('cardCsv');
    }

    if (!RapidStorSettings(location).autobill().required()) {
        excl.push('autobillType');
    }

    if (!RapidStorSettings(location).passwordFields().show()) {
        excl.push('password');
        excl.push('confirmPassword');
    }

    if (!RapidStorSettings(location).alternateContact().email().required()) {
        excl.push('email_alternate');
    }

    if (!RapidStorSettings(location).alternateContact().phoneNumber().required()) {
        excl.push('phone_alternate');
    }

    if (!RapidStorSettings(location).alternateContact().addressDetails().required()) {
        excl.push('address_alternate');
        excl.push('city_alternate');
        excl.push('state_alternate');
        excl.push('postcode_alternate');
    }

    return excl.filter((item, index) => excl.indexOf(item) === index);
};

export const normaliseFieldName = (name: string): string => {
    const spaced = name
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    const split = spaced.replace(/([A-Z])/g, ' $1');

    return split.replace(/\s{2,}/g, ' ');
};

export const getAutobillFields = (
    location: Location,
    cc: boolean,
    usePaymentDetails: boolean
) => {
    const fields: string[] = ['bank'];

    if (RapidStorSettings(location).autobill().required()) {
        if (cc) {
            if (!usePaymentDetails) {
                fields.push(
                    'autobillCreditCardExpiryMonth',
                    'autobillCreditCardExpiryYear',
                    'autobillCreditCardNumber',
                    'autobillCreditCardCsv',
                    'autobillCreditCardName'
                );
            }
        } else {
            fields.push('autobillBsbNumber', 'autobillAccountNumber');
        }
    }

    return fields;
};
